import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=7d57e3dc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=7d57e3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57e3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d57e3dc')) {
      api.createRecord('7d57e3dc', component.options)
    } else {
      api.reload('7d57e3dc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=7d57e3dc&scoped=true&", function () {
      api.rerender('7d57e3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Hy3XL3PKK4Vk/JS/comp/PopupBox.vue"
export default component.exports